'use strict';

var Cleave = require('cleave.js').default;
require('cleave.js/dist/addons/cleave-phone.us');

module.exports = {
    formatPhoneNumber: function (phoneFieldSelector, phoneCountry) {
        var cleave = new Cleave(phoneFieldSelector, {
            phone: true,
            phoneRegionCode: phoneCountry
        });

        $(phoneFieldSelector).data('cleave', cleave);
    }
};
